import { useEffect, useState } from 'react'

import DownloadIcon from '../Icons/DownloadIcon'

const S3_BASE_URL =
  'https://directful-desktop-app.s3.us-west-2.amazonaws.com/updates/squirrel.windows/ia32'

const RELEASES_URL = `${S3_BASE_URL}/RELEASES?nocache=${Date.now()}`

function parseReleasesFile(content) {
  const lines = content.split('\n')
  let latestVersion = '0.0.0'

  lines.forEach(line => {
    const parts = line.split(' ')
    if (parts.length >= 2) {
      const filename = parts[1]
      const versionMatch = filename.match(/directful-desktop-app-(\d+\.\d+\.\d+)/)
      if (versionMatch && versionMatch[1]) {
        const version = versionMatch[1]
        const compareVersionResult = compareVersions(version, latestVersion)
        if (compareVersionResult > 0) {
          latestVersion = version
        }
      }
    }
  })

  return latestVersion
}

function compareVersions(a, b) {
  const aParts = a.split('.').map(Number)
  const bParts = b.split('.').map(Number)

  for (let i = 0; i < 3; i++) {
    if (aParts[i] > bParts[i]) return 1
    if (aParts[i] < bParts[i]) return -1
  }
  return 0
}

export function LatestVersionLink({ shouldRedirect = false }) {
  const [latestVersion, setLatestVersion] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetch(RELEASES_URL)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch RELEASES file')
        }
        return response.text()
      })
      .then(content => {
        const version = parseReleasesFile(content)
        setLatestVersion(version)

        const downloadUrl = `${S3_BASE_URL}/Directful-${version}+Setup.exe`

        if (shouldRedirect) {
          window.location.href = downloadUrl
        }
      })
      .catch(err => {
        console.error('Error fetching latest version:', err)
        setError(err.message)
      })
  }, [shouldRedirect])

  if (error) {
    return <div>Error: {error}</div>
  }

  if (!latestVersion) {
    return <div>Loading...</div>
  }

  const downloadUrl = `${S3_BASE_URL}/Directful-${latestVersion}+Setup.exe`

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        width: '100%',
        height: 200,
        flexDirection: 'column'
      }}
    >
      <a
        href={downloadUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
      >
        <DownloadIcon />
        Download Directful {latestVersion}
      </a>
      {shouldRedirect ? (
        <div>
          Your download should start shortly. If it doesn’t,{' '}
          <a href={downloadUrl} rel="noopener noreferrer">
            click here
          </a>{' '}
          to start it manually.
        </div>
      ) : null}
    </div>
  )
}
